/* eslint-disable no-unneeded-ternary */
import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const container: SxStyleFunc<string | undefined> = (color) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: color ? color : (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(2),
  mt: (p) => p.spacing(2.75),
  mx: (p) => p.spacing(2.75),
});

export const logoContainer: SxStyleFunc<string | undefined> = (color) => ({
  borderRightWidth: '1px',
  borderRightStyle: 'solid',
  borderRightColor: color ? color : (p) => p.palette.primary[100],
  padding: (p) => p.spacing(2, 1),
});

export const logo: SxStyle = {
  width: (p) => p.spacing(4),
  height: (p) => p.spacing(4),
  background: (p) => p.palette.success[100],
  borderRadius: (p) => p.spacing(0.5),
  m: 'auto',
};

export const content: SxStyle = {
  pl: (p) => p.spacing(4),
};

export const text1: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: 900,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: (p) => p.spacing(20),
};

export const text2: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  color: (p) => p.palette.grey[500],
};

export const text3: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};
